export function isTruthy<T>(value: T | null | undefined | false): value is T {
  return !!value;
}

export function isDefined<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
